import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-work-order-view',
  templateUrl: './work-order-view.component.html',
  styleUrls: ['./work-order-view.component.css']
})
export class WorkOrderViewComponent implements OnInit {
  workOrder: any = null;
  loading = false;
  workOrderId: number | null = null;
  accessToken: string | null = null;
  isPublicView = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrMsgService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.workOrderId = +params['id'];
      this.route.queryParams.subscribe(queryParams => {
        this.accessToken = queryParams['token'] || null;
        this.isPublicView = !!this.accessToken;
        this.loadWorkOrder();
      });
    });
  }

  loadWorkOrder() {
    this.loading = true;
    
    const observable = this.accessToken
      ? this.apiService.getWorkOrderByToken(this.accessToken)
      : this.apiService.getWorkOrderById(this.workOrderId!);

    observable.subscribe({
      next: (res: any) => {
        if (res.success) {
          this.workOrder = res.data;
        } else {
          this.toastrService.error('Failed to load work order');
        }
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error loading work order:', err);
        this.toastrService.error(err.error?.error || 'Failed to load work order');
        this.loading = false;
      }
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  }

  printWorkOrder() {
    window.print();
  }

  downloadPDF() {
    if (this.workOrderId) {
      this.apiService.generateWorkOrderPDF(this.workOrderId).subscribe({
        next: (res: any) => {
          if (res.success) {
            // Generate PDF on frontend using the data
            this.generatePDFFromData(res.data);
          }
        },
        error: (err: any) => {
          console.error('Error generating PDF:', err);
          this.toastrService.error('Failed to generate PDF');
        }
      });
    }
  }

  generatePDFFromData(data: any) {
    // This would use a PDF library like jsPDF or html2pdf
    // For now, just print the page
    window.print();
  }

  goBack() {
    this.router.navigate(['/home/work-orders']);
  }

  editWorkOrder() {
    if (this.workOrderId) {
      this.router.navigate(['/home/work-orders', this.workOrderId, 'edit']);
    }
  }
}

